import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'

export const paymentProcessorsRequiredFields: Record<
  PaymentMethodEnum,
  FieldSlugEnum[]
> = {
  [PaymentMethodEnum.StripeCard]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.StripeIDeal]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
  ],
  [PaymentMethodEnum.StripeKlarna]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
  ],
  [PaymentMethodEnum.StripeMultibanco]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.StripeSepaDebit]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.StripeBancontact]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
  ],
  [PaymentMethodEnum.PaypalSoap]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.PaypalRest]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.DlocalCard]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.TaxNumber,
  ],
  [PaymentMethodEnum.DlocalBoleto]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
    FieldSlugEnum.Surname,
    FieldSlugEnum.TaxNumber,
  ],
  [PaymentMethodEnum.DlocalPix]: [FieldSlugEnum.Email, FieldSlugEnum.TaxNumber],
  [PaymentMethodEnum.MercadoPagoCard]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.MercadoPagoPix]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.MercadoPagoBrCard]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.TaxNumber,
  ],
  [PaymentMethodEnum.MercadoPagoBrPix]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.TaxNumber,
  ],
  [PaymentMethodEnum.MercadoPagoBrBoleto]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
    FieldSlugEnum.Surname,
    FieldSlugEnum.TaxNumber,
  ],
  [PaymentMethodEnum.MercadoPagoCoCard]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.TaxNumber,
  ],
  // tax field is not required for Mexico MP
  // https://developer.spreedly.com/docs/mercado-pago-gateway-guide#payer-identification
  [PaymentMethodEnum.MercadoPagoMxCard]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.MercadoPagoArCard]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.TaxNumber,
  ],
  [PaymentMethodEnum.MercadoPagoClCard]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.TaxNumber,
  ],
  [PaymentMethodEnum.MercadoPagoBoleto]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.RazorpayCard]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.Flutterwave]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.Mollie]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.Gocardless]: [FieldSlugEnum.Email],
  [PaymentMethodEnum.XenditIdCard]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
    FieldSlugEnum.Surname,
    FieldSlugEnum.PhoneNumber,
  ],
  [PaymentMethodEnum.XenditPhCard]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
    FieldSlugEnum.Surname,
    FieldSlugEnum.PhoneNumber,
  ],
  [PaymentMethodEnum.CashOnDelivery]: [],
  [PaymentMethodEnum.StripeApplepay]: [],
  [PaymentMethodEnum.XenditIdDd]: [],
  [PaymentMethodEnum.XenditIdEwallet]: [],
  [PaymentMethodEnum.XenditPhDd]: [],
  [PaymentMethodEnum.XenditPhEwallet]: [],
  [PaymentMethodEnum.PaystackGhCard]: [],
  [PaymentMethodEnum.PaystackKeCard]: [],
  [PaymentMethodEnum.PaystackNgCard]: [],
  [PaymentMethodEnum.PaystackZaCard]: [],
  [PaymentMethodEnum.PaystackEgCard]: [],
  [PaymentMethodEnum.PaystackCiCard]: [],
  [PaymentMethodEnum.SecureAndPay]: [
    FieldSlugEnum.Email,
    FieldSlugEnum.FirstName,
    FieldSlugEnum.Surname,
  ],
}
